import { GetVoucherOverviewTC, ApplyVoucherCodeTC } from './voucher.thunk'

export const voucherAsyncActions = {
  GetVoucherOverviewTC,
  ApplyVoucherCodeTC,
}
